import * as React from 'react';
import i18next from 'i18next';
import Button from "@material-ui/core/Button";

export default function Requisites(props) {
  return (
    <div style={{ marginLeft: 10, marginTop: 10 }}>
      {props.req_list.map(function (item, index) {
        return (
          <div
            key={index}
            style={{
              display: "flex",
              flex: 1,
              flexWrap: "wrap",
              flexDirection: "row",
              marginBottom: 10,
              alignItems: "center",
            }}
          >
            <div style={{ width: 400, maxWidth: "100%", marginRight: 10, fontSize: 16, paddingTop: 10 }}>
              {item}
            </div>
            <input
              placeholder={item}
              style={{ flex: 1, minWidth: 200, maxWidth: "100%" }}
              value={props.req_data[index] ? props.req_data[index].val : ""}
              onChange={e => props.setReq(index, e.target.value)}
            />
          </div>
        );
      })}
      <Button variant="contained" onClick={props.onSave} style={{ marginTop: 10 }}>
        {i18next.t("btn_save")}
      </Button>
    </div>
  );
}
